/**
 * Generated by orval v7.11.2 🍺
 * Do not edit manually.
 * ScaleFi Nub APIs
 * Scale Fi Apis
 * OpenAPI spec version: v0.0.1
 */
import {
  useMutation,
  useQuery
} from '@tanstack/react-query';
import type {
  DataTag,
  DefinedInitialDataOptions,
  DefinedUseQueryResult,
  MutationFunction,
  QueryClient,
  QueryFunction,
  QueryKey,
  UndefinedInitialDataOptions,
  UseMutationOptions,
  UseMutationResult,
  UseQueryOptions,
  UseQueryResult
} from '@tanstack/react-query';

import type {
  CountFxChartsParams,
  FxChartDTO,
  GetAllFxChartsParams
} from '../model';

import { customInstance } from '../mutator/custom-instance';



type SecondParameter<T extends (...args: never) => unknown> = Parameters<T>[1];



export const getAllFxCharts = (
    params: GetAllFxChartsParams,
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {
      
      
      return customInstance<FxChartDTO[]>(
      {url: `/api/fx-charts`, method: 'GET',
        params, signal
    },
      options);
    }
  

export const getGetAllFxChartsQueryKey = (params?: GetAllFxChartsParams,) => {
    return [`/api/fx-charts`, ...(params ? [params]: [])] as const;
    }

    
export const getGetAllFxChartsQueryOptions = <TData = Awaited<ReturnType<typeof getAllFxCharts>>, TError = unknown>(params: GetAllFxChartsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getAllFxCharts>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetAllFxChartsQueryKey(params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getAllFxCharts>>> = ({ signal }) => getAllFxCharts(params, requestOptions, signal);

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getAllFxCharts>>, TError, TData> & { queryKey: DataTag<QueryKey, TData> }
}

export type GetAllFxChartsQueryResult = NonNullable<Awaited<ReturnType<typeof getAllFxCharts>>>
export type GetAllFxChartsQueryError = unknown


export function useGetAllFxCharts<TData = Awaited<ReturnType<typeof getAllFxCharts>>, TError = unknown>(
 params: GetAllFxChartsParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getAllFxCharts>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getAllFxCharts>>,
          TError,
          Awaited<ReturnType<typeof getAllFxCharts>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
export function useGetAllFxCharts<TData = Awaited<ReturnType<typeof getAllFxCharts>>, TError = unknown>(
 params: GetAllFxChartsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getAllFxCharts>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getAllFxCharts>>,
          TError,
          Awaited<ReturnType<typeof getAllFxCharts>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
export function useGetAllFxCharts<TData = Awaited<ReturnType<typeof getAllFxCharts>>, TError = unknown>(
 params: GetAllFxChartsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getAllFxCharts>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }

export function useGetAllFxCharts<TData = Awaited<ReturnType<typeof getAllFxCharts>>, TError = unknown>(
 params: GetAllFxChartsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getAllFxCharts>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {

  const queryOptions = getGetAllFxChartsQueryOptions(params,options)

  const query = useQuery(queryOptions , queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}



export const updateFxChart = (
    fxChartDTO: FxChartDTO,
 options?: SecondParameter<typeof customInstance>,) => {
      
      
      return customInstance<FxChartDTO>(
      {url: `/api/fx-charts`, method: 'PUT',
      headers: {'Content-Type': 'application/json', },
      data: fxChartDTO
    },
      options);
    }
  


export const getUpdateFxChartMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updateFxChart>>, TError,{data: FxChartDTO}, TContext>, request?: SecondParameter<typeof customInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof updateFxChart>>, TError,{data: FxChartDTO}, TContext> => {

const mutationKey = ['updateFxChart'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof updateFxChart>>, {data: FxChartDTO}> = (props) => {
          const {data} = props ?? {};

          return  updateFxChart(data,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type UpdateFxChartMutationResult = NonNullable<Awaited<ReturnType<typeof updateFxChart>>>
    export type UpdateFxChartMutationBody = FxChartDTO
    export type UpdateFxChartMutationError = unknown

    export const useUpdateFxChart = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updateFxChart>>, TError,{data: FxChartDTO}, TContext>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof updateFxChart>>,
        TError,
        {data: FxChartDTO},
        TContext
      > => {

      const mutationOptions = getUpdateFxChartMutationOptions(options);

      return useMutation(mutationOptions , queryClient);
    }
    export const createFxChart = (
    fxChartDTO: FxChartDTO,
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {
      
      
      return customInstance<FxChartDTO>(
      {url: `/api/fx-charts`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: fxChartDTO, signal
    },
      options);
    }
  


export const getCreateFxChartMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createFxChart>>, TError,{data: FxChartDTO}, TContext>, request?: SecondParameter<typeof customInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof createFxChart>>, TError,{data: FxChartDTO}, TContext> => {

const mutationKey = ['createFxChart'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof createFxChart>>, {data: FxChartDTO}> = (props) => {
          const {data} = props ?? {};

          return  createFxChart(data,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type CreateFxChartMutationResult = NonNullable<Awaited<ReturnType<typeof createFxChart>>>
    export type CreateFxChartMutationBody = FxChartDTO
    export type CreateFxChartMutationError = unknown

    export const useCreateFxChart = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createFxChart>>, TError,{data: FxChartDTO}, TContext>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof createFxChart>>,
        TError,
        {data: FxChartDTO},
        TContext
      > => {

      const mutationOptions = getCreateFxChartMutationOptions(options);

      return useMutation(mutationOptions , queryClient);
    }
    export const getFxChart = (
    fxCrncy: string,
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {
      
      
      return customInstance<FxChartDTO>(
      {url: `/api/fx-charts/${fxCrncy}`, method: 'GET', signal
    },
      options);
    }
  

export const getGetFxChartQueryKey = (fxCrncy?: string,) => {
    return [`/api/fx-charts/${fxCrncy}`] as const;
    }

    
export const getGetFxChartQueryOptions = <TData = Awaited<ReturnType<typeof getFxChart>>, TError = unknown>(fxCrncy: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getFxChart>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetFxChartQueryKey(fxCrncy);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getFxChart>>> = ({ signal }) => getFxChart(fxCrncy, requestOptions, signal);

      

      

   return  { queryKey, queryFn, enabled: !!(fxCrncy), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getFxChart>>, TError, TData> & { queryKey: DataTag<QueryKey, TData> }
}

export type GetFxChartQueryResult = NonNullable<Awaited<ReturnType<typeof getFxChart>>>
export type GetFxChartQueryError = unknown


export function useGetFxChart<TData = Awaited<ReturnType<typeof getFxChart>>, TError = unknown>(
 fxCrncy: string, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getFxChart>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getFxChart>>,
          TError,
          Awaited<ReturnType<typeof getFxChart>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
export function useGetFxChart<TData = Awaited<ReturnType<typeof getFxChart>>, TError = unknown>(
 fxCrncy: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getFxChart>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getFxChart>>,
          TError,
          Awaited<ReturnType<typeof getFxChart>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
export function useGetFxChart<TData = Awaited<ReturnType<typeof getFxChart>>, TError = unknown>(
 fxCrncy: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getFxChart>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }

export function useGetFxChart<TData = Awaited<ReturnType<typeof getFxChart>>, TError = unknown>(
 fxCrncy: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getFxChart>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {

  const queryOptions = getGetFxChartQueryOptions(fxCrncy,options)

  const query = useQuery(queryOptions , queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}



export const deleteFxChart = (
    fxCrncy: string,
 options?: SecondParameter<typeof customInstance>,) => {
      
      
      return customInstance<null>(
      {url: `/api/fx-charts/${fxCrncy}`, method: 'DELETE'
    },
      options);
    }
  


export const getDeleteFxChartMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deleteFxChart>>, TError,{fxCrncy: string}, TContext>, request?: SecondParameter<typeof customInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof deleteFxChart>>, TError,{fxCrncy: string}, TContext> => {

const mutationKey = ['deleteFxChart'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof deleteFxChart>>, {fxCrncy: string}> = (props) => {
          const {fxCrncy} = props ?? {};

          return  deleteFxChart(fxCrncy,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type DeleteFxChartMutationResult = NonNullable<Awaited<ReturnType<typeof deleteFxChart>>>
    
    export type DeleteFxChartMutationError = unknown

    export const useDeleteFxChart = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deleteFxChart>>, TError,{fxCrncy: string}, TContext>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof deleteFxChart>>,
        TError,
        {fxCrncy: string},
        TContext
      > => {

      const mutationOptions = getDeleteFxChartMutationOptions(options);

      return useMutation(mutationOptions , queryClient);
    }
    export const countFxCharts = (
    params: CountFxChartsParams,
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {
      
      
      return customInstance<number>(
      {url: `/api/fx-charts/count`, method: 'GET',
        params, signal
    },
      options);
    }
  

export const getCountFxChartsQueryKey = (params?: CountFxChartsParams,) => {
    return [`/api/fx-charts/count`, ...(params ? [params]: [])] as const;
    }

    
export const getCountFxChartsQueryOptions = <TData = Awaited<ReturnType<typeof countFxCharts>>, TError = unknown>(params: CountFxChartsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof countFxCharts>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getCountFxChartsQueryKey(params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof countFxCharts>>> = ({ signal }) => countFxCharts(params, requestOptions, signal);

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof countFxCharts>>, TError, TData> & { queryKey: DataTag<QueryKey, TData> }
}

export type CountFxChartsQueryResult = NonNullable<Awaited<ReturnType<typeof countFxCharts>>>
export type CountFxChartsQueryError = unknown


export function useCountFxCharts<TData = Awaited<ReturnType<typeof countFxCharts>>, TError = unknown>(
 params: CountFxChartsParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof countFxCharts>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof countFxCharts>>,
          TError,
          Awaited<ReturnType<typeof countFxCharts>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
export function useCountFxCharts<TData = Awaited<ReturnType<typeof countFxCharts>>, TError = unknown>(
 params: CountFxChartsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof countFxCharts>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof countFxCharts>>,
          TError,
          Awaited<ReturnType<typeof countFxCharts>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
export function useCountFxCharts<TData = Awaited<ReturnType<typeof countFxCharts>>, TError = unknown>(
 params: CountFxChartsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof countFxCharts>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }

export function useCountFxCharts<TData = Awaited<ReturnType<typeof countFxCharts>>, TError = unknown>(
 params: CountFxChartsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof countFxCharts>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {

  const queryOptions = getCountFxChartsQueryOptions(params,options)

  const query = useQuery(queryOptions , queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}



